export default "__VITE_ASSET__65363f65__"